import * as angular from "angular";

let ErrorResultsComponent = {
    selector: "vcErrorResults",
    templateUrl: "/angular/components/help-text/error-results.component.html",
    bindings: {
        supportDocLink: "=?",
    },
    controller: class ErrorResultsController {
        // * bindings for typescript compiler *
        public supportDocLink?: string;
        // ************************************
    },
};

angular
    .module("helpText", [])
    .component(ErrorResultsComponent.selector, ErrorResultsComponent);
